module.exports = __webpack_public_path__ + "media/game-over.e58f3f17.wav";